module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot17-2560x1440.fc64ae65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot17-2560x1440.jpg
// module id = 1069
// module chunks = 37